'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

___$insertStyle("/*\n* ink colors (with variations only for black and white)\n*/\n.np-root {\n  position: relative;\n  color: #1D66DD;\n  display: flex;\n  align-items: center;\n  text-decoration: unset;\n  width: 40px;\n  height: auto;\n}\n@media (min-width: 1200px) {\n  .np-root {\n    width: auto;\n  }\n}\n.np-root a {\n  font-family: \"Montserrat\";\n  font-size: 14px;\n  color: #fff;\n  text-decoration: none;\n  background-color: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n}\n@media (min-width: 1200px) {\n  .np-root a {\n    gap: 4px;\n    background-color: #1855B8;\n    padding: 0 12px;\n    width: auto;\n    border-radius: 4px;\n  }\n}\n.np-root a svg {\n  width: 40px;\n  height: 40px;\n  min-width: 40px;\n  min-height: 40px;\n  fill: #1D66DD;\n}\n@media (min-width: 1200px) {\n  .np-root a svg {\n    width: 20px;\n    height: 20px;\n    min-width: 20px;\n    min-height: 20px;\n    fill: #fff;\n  }\n}\n.np-root a span {\n  display: none;\n}\n@media (min-width: 1200px) {\n  .np-root a span {\n    display: block;\n  }\n}");
//# sourceMappingURL=NavbarProfile.scss.js.map
